import { useEffect } from "react";
const useKeyDown = (key, action) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === key) {
        action();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    //Remove the event listener when the component is unmounted
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};
export default useKeyDown;
